import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { withLeadingZero } from '@bedrock-rdk/utils';
import Pill from '../pill/pill.component';
import { defaultContext, getInitialStyle, getTextStyle } from './epgTimeline.style';

export class EpgTimeline extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Marks: {},
        Current: {
          type: Pill,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._maxOffset = 0;
  }

  _build() {
    const end = 24 * 60;
    const marks = end / 15;
    const children = [];
    const textStyle = getTextStyle(this._style.screenSize);
    const textY = Math.round((32 - textStyle.lineHeight) / 2);
    this._maxOffset = 0;

    for (let i = 0; i <= marks; i += 1) {
      const isHour = i % 4 === 0;
      const h = isHour ? 32 : 16;
      const x = i * 15 * 6;

      children.push({
        rect: true,
        w: 2,
        h,
        x,
        y: (32 - h) / 2,
      });

      if (isHour) {
        const hour = (6 + (i * 15) / 60) % 24;

        children.push({
          x: x + 4,
          y: textY,
          text: {
            ...textStyle,
            text: `${withLeadingZero(hour)}:00`,
          },
        });
      }

      this._maxOffset = x;
    }

    this.tag('Marks').children = children;
  }

  set range(value) {
    if (!value) {
      return;
    }

    const { start, end } = value;
    if (!start || !end) {
      return;
    }

    this._start = start.getTime();
    this._end = end.getTime();
  }

  set currentTime(value) {
    const hour = value.getHours();
    const minute = value.getMinutes();
    const time = value.getTime();
    const offset = (time - this._start) / (this._end - this._start);
    const x = this._maxOffset * offset;

    this.tag('Current').patch({
      visible: x > 0,
      x: this._maxOffset * offset,
      label: `${withLeadingZero(hour)}:${withLeadingZero(minute)}`,
    });
  }
}
